<script setup>

    import { computed, ref, onMounted, nextTick } from "vue";
    import ChatbotAnswerList                      from "./ChatbotAnswerList.vue";

    let props = defineProps(["question","index"])
    let emits = defineEmits(["onAnswer", "onScrollToBottom"])

    function isFollow (qIndex)
    {
        return qIndex !== 0 ? "follow" : "";
    }


    //let questions = computed ( () => props.question.questions ?? [] );
    let questions = ref ( []);
    let currentIndex = ref(0);
    let currentIndexThinking = ref(0);

    let hideThinkingAt = ref(0);
    let showAnswers = ref(false)

    let waitForQuestionMS = computed ( () => parseFloat(props.question.wait_q ?? 1) * 1000)

    function showNextQuestion ()
    {
        if (currentIndex.value >= props.question.questions.length)
        {
            showAnswers.value = true;
            return;
        }

        questions.value.push ( props.question.questions[currentIndex.value]);
        currentIndex.value++;

        hideThinkingAt.value = new Date().getTime() + waitForQuestionMS.value;

        emits("onScrollToBottom");

        requestAnimationFrame (onNextTick);
    }

    function showThinking ()
    {
        currentIndexThinking.value = currentIndex.value;
        hideThinkingAt.value = currentIndex.value + 1;
    }

    function isThinking (qIndex)
    {
        return qIndex === currentIndexThinking.value;
    }

    function onNextTick ()
    {
        //we want to avoid setTimeout

        if (hideThinkingAt.value > 0)
        {
            let now = new Date().getTime();

            let diff = hideThinkingAt.value - now;

            if (diff <= 0)
            {
                hideThinkingAt.value = 0;
                currentIndexThinking.value++;

                showNextQuestion();

                return;
            }

            requestAnimationFrame (onNextTick);
        }
    }

    function onAnswer (answer)
    {
/*console.log(("onAnswer", answer))*/;
        emits('onAnswer', answer);
    }





    showNextQuestion();


</script>

<template>
    <div
        v-for="(oneQuestion,qIndex) in questions"
        class="d-flex question-group">

        <div class="chatbot-avatar" v-if="qIndex === 0"></div>

        <div class="chatbot-avatar" v-else style="visibility: hidden"></div>

        <div class="response bot" :class="isFollow(qIndex)" v-if="!isThinking(qIndex)" v-html="oneQuestion"></div>

        <div class="d-flex" v-if="isThinking(qIndex)">
            <div class="response bot anim"></div>
        </div>



    </div>

    <chatbot-answer-list
        v-if="showAnswers"
        :displayMode="props.question.displayMode"
        :answers="question.answers"
        @onScrollToBottom="emits('onScrollToBottom')"
        @onAnswer="onAnswer"></chatbot-answer-list>
</template>

<style scoped>

</style>
